var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnotationQuestion = function SvgAnnotationQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.167 5.668a1.499 1.499 0 0 1 2.912.5c0 .999-1.498 1.499-1.498 1.499m.019 2h.007M7.1 12.8l.973 1.298c.145.193.217.29.306.324.078.03.164.03.242 0 .089-.035.16-.131.306-.324L9.9 12.8c.195-.26.293-.39.412-.49.16-.133.347-.227.548-.274.151-.036.314-.036.64-.036.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083c.152-.367.152-.833.152-1.765V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C12.98 2 12.42 2 11.3 2H5.7c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2.5 3.52 2.5 4.08 2.5 5.2V9c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.102 12 4.568 12 5.5 12c.326 0 .489 0 .64.036.201.047.389.141.548.274.119.1.217.23.412.49"
  })));
};
export default SvgAnnotationQuestion;